import { render, staticRenderFns } from "./InstallmentState.vue?vue&type=template&id=28bddff0"
import script from "./InstallmentState.vue?vue&type=script&lang=js"
export * from "./InstallmentState.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports